export const dataHooks = {
  audioPlayerPlayPause: 'audioPlayer-play-pause',
  audioPlayerPlay: 'audioPlayer-play',
  audioPlayerPause: 'audioPlayer-pause',
  audioPlayerLoad: 'audioPlayer-load',
  audioPlayerSlider: 'audioPlayer-slider',
  audioPlayerSliderHandle: 'audioPlayer-slider-handle',
  audioTimeIndicator: 'audioPlayer-time-indicator',
};
